// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/veselka.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  CategoryCollectionProfile,
  SessionActivityState,
  sessionActivityStateFromJSON,
  sessionActivityStateToJSON,
} from "../veselka/prediction_point";
import { DB } from "./db";

export const protobufPackage = "carbon.portal.veselka";

export interface Image {
  id: string;
  location: string;
  robotId: string;
  useCase: string;
  role: string;
  created: number;
  url: string;
  height: number;
  width: number;
  ppi: number;
  valid: number;
  capturedAt: number;
  detectionJson: string;
  reasonJson: string;
  priority: string;
  camId: string;
  rowId: string;
  geoJson: string;
  crop: string;
  imageType: string;
  city: string;
  correctedHw: boolean;
  sessionName: string;
  cropId: string;
  focusMetric: number;
  geohash: string;
  quarantineReason: string;
}

export interface CropConfidence {
  db: DB | undefined;
  robotId: number;
  cropId: string;
  latitude: number;
  longitude: number;
  precision: number;
  numTotalImages: number;
  numRegionalImages: number;
  confidence: string;
}

export interface Crop {
  archived: boolean;
  carbonName: string;
  commonName: string;
  created: number;
  description: string;
  id: string;
  legacyCropName: string;
  /** @deprecated */
  notes: string;
  updated: number;
  captureOnly: boolean;
  translations: CropTranslation[];
}

export interface CropTranslation {
  language: string;
  name: string;
  version: number;
}

export interface RobotCrop {
  crop: Crop | undefined;
  confidence: CropConfidence | undefined;
}

export interface Model {
  id: string;
  created: number;
  updated: number;
  url: string;
  customer: string;
  crop: string;
  version: number;
  trainingDockerTag: string;
  gitSha: string;
  checksum: string;
  location: string;
  trainedAt: number;
  type: string;
  description: string;
  metadataJson: string;
  productionContainerVersion: string;
  testResultsJson: string;
  wandbJson: string;
  snapshotJson: string;
  isStub: boolean;
  isGoodToDeploy: boolean;
  robotName: string;
  environment: string;
  deploy: boolean;
  isPretraining: boolean;
  subType: string;
  datasetId: string;
  containerVersion: string;
  containerId: string;
  pipelineId: string;
  parentModelId: string;
  viableCropIds: string[];
}

export interface PageSortParams {
  page: number;
  pageSize: number;
  sortBy?:
    | string
    | undefined;
  /** "ASC" or "DESC" */
  sortDirection?: string | undefined;
}

export interface PredictionPointSessionFilters {
  sessionId?: string | undefined;
  categoryIds: string[];
}

export interface PredictionPointBaseFilters {
  ids: string[];
  capturedAtStart?: string | undefined;
  capturedAtEnd?:
    | string
    | undefined;
  /** radius in mm */
  radiusMin?:
    | number
    | undefined;
  /** radius in mm */
  radiusMax?:
    | number
    | undefined;
  /** Veselka Crops */
  cropIds: string[];
  robotSerials: string[];
  uploadedByOperator?: boolean | undefined;
  customerIds: string[];
  /**
   * Portal-only: expand plant-profile category chip_ids into ids before calling
   * Veselka.
   */
  ppCategoryId?:
    | string
    | undefined;
  /**
   * Carbon Crops
   * Portal expands these to associated Veselka crop IDs unless `crop_ids` is
   * already set.
   */
  carbonCropIds: string[];
}

export interface CreateCategoryCollectionSessionRequest {
  modelId: string;
  /** @deprecated */
  customerId?:
    | number
    | undefined;
  /** customer_uuid is intended to replace customer_id */
  customerUuid?: string | undefined;
  plantProfile: CategoryCollectionProfile | undefined;
  filters?: PredictionPointBaseFilters | undefined;
}

export interface CreateCategoryCollectionSessionResponse {
  sessionId: string;
  status: SessionActivityState;
  /**
   * Veselka crop IDs actually sent to Veselka at session create, including
   * Carbon crop associations expanded at that moment. Polls and session-scoped
   * lists should reuse these so the filter checksum stays stable.
   */
  cropIds: string[];
}

function createBaseImage(): Image {
  return {
    id: "",
    location: "",
    robotId: "",
    useCase: "",
    role: "",
    created: 0,
    url: "",
    height: 0,
    width: 0,
    ppi: 0,
    valid: 0,
    capturedAt: 0,
    detectionJson: "",
    reasonJson: "",
    priority: "",
    camId: "",
    rowId: "",
    geoJson: "",
    crop: "",
    imageType: "",
    city: "",
    correctedHw: false,
    sessionName: "",
    cropId: "",
    focusMetric: 0,
    geohash: "",
    quarantineReason: "",
  };
}

export const Image: MessageFns<Image> = {
  encode(message: Image, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.location !== "") {
      writer.uint32(18).string(message.location);
    }
    if (message.robotId !== "") {
      writer.uint32(26).string(message.robotId);
    }
    if (message.useCase !== "") {
      writer.uint32(34).string(message.useCase);
    }
    if (message.role !== "") {
      writer.uint32(42).string(message.role);
    }
    if (message.created !== 0) {
      writer.uint32(48).int64(message.created);
    }
    if (message.url !== "") {
      writer.uint32(58).string(message.url);
    }
    if (message.height !== 0) {
      writer.uint32(64).int64(message.height);
    }
    if (message.width !== 0) {
      writer.uint32(72).int64(message.width);
    }
    if (message.ppi !== 0) {
      writer.uint32(80).int64(message.ppi);
    }
    if (message.valid !== 0) {
      writer.uint32(88).int64(message.valid);
    }
    if (message.capturedAt !== 0) {
      writer.uint32(96).int64(message.capturedAt);
    }
    if (message.detectionJson !== "") {
      writer.uint32(106).string(message.detectionJson);
    }
    if (message.reasonJson !== "") {
      writer.uint32(114).string(message.reasonJson);
    }
    if (message.priority !== "") {
      writer.uint32(122).string(message.priority);
    }
    if (message.camId !== "") {
      writer.uint32(130).string(message.camId);
    }
    if (message.rowId !== "") {
      writer.uint32(138).string(message.rowId);
    }
    if (message.geoJson !== "") {
      writer.uint32(146).string(message.geoJson);
    }
    if (message.crop !== "") {
      writer.uint32(154).string(message.crop);
    }
    if (message.imageType !== "") {
      writer.uint32(162).string(message.imageType);
    }
    if (message.city !== "") {
      writer.uint32(170).string(message.city);
    }
    if (message.correctedHw !== false) {
      writer.uint32(176).bool(message.correctedHw);
    }
    if (message.sessionName !== "") {
      writer.uint32(186).string(message.sessionName);
    }
    if (message.cropId !== "") {
      writer.uint32(194).string(message.cropId);
    }
    if (message.focusMetric !== 0) {
      writer.uint32(200).int64(message.focusMetric);
    }
    if (message.geohash !== "") {
      writer.uint32(210).string(message.geohash);
    }
    if (message.quarantineReason !== "") {
      writer.uint32(218).string(message.quarantineReason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Image {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.useCase = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.created = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.height = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.width = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.ppi = longToNumber(reader.int64());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.valid = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.capturedAt = longToNumber(reader.int64());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.detectionJson = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.reasonJson = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.priority = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.camId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.rowId = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.geoJson = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.crop = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.imageType = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.correctedHw = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.sessionName = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.cropId = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.focusMetric = longToNumber(reader.int64());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.geohash = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.quarantineReason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Image {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      robotId: isSet(object.robotId)
        ? globalThis.String(object.robotId)
        : isSet(object.robot_id)
        ? globalThis.String(object.robot_id)
        : "",
      useCase: isSet(object.useCase)
        ? globalThis.String(object.useCase)
        : isSet(object.use_case)
        ? globalThis.String(object.use_case)
        : "",
      role: isSet(object.role) ? globalThis.String(object.role) : "",
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      ppi: isSet(object.ppi) ? globalThis.Number(object.ppi) : 0,
      valid: isSet(object.valid) ? globalThis.Number(object.valid) : 0,
      capturedAt: isSet(object.capturedAt)
        ? globalThis.Number(object.capturedAt)
        : isSet(object.captured_at)
        ? globalThis.Number(object.captured_at)
        : 0,
      detectionJson: isSet(object.detectionJson)
        ? globalThis.String(object.detectionJson)
        : isSet(object.detection_json)
        ? globalThis.String(object.detection_json)
        : "",
      reasonJson: isSet(object.reasonJson)
        ? globalThis.String(object.reasonJson)
        : isSet(object.reason_json)
        ? globalThis.String(object.reason_json)
        : "",
      priority: isSet(object.priority) ? globalThis.String(object.priority) : "",
      camId: isSet(object.camId)
        ? globalThis.String(object.camId)
        : isSet(object.cam_id)
        ? globalThis.String(object.cam_id)
        : "",
      rowId: isSet(object.rowId)
        ? globalThis.String(object.rowId)
        : isSet(object.row_id)
        ? globalThis.String(object.row_id)
        : "",
      geoJson: isSet(object.geoJson)
        ? globalThis.String(object.geoJson)
        : isSet(object.geo_json)
        ? globalThis.String(object.geo_json)
        : "",
      crop: isSet(object.crop) ? globalThis.String(object.crop) : "",
      imageType: isSet(object.imageType)
        ? globalThis.String(object.imageType)
        : isSet(object.image_type)
        ? globalThis.String(object.image_type)
        : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      correctedHw: isSet(object.correctedHw)
        ? globalThis.Boolean(object.correctedHw)
        : isSet(object.corrected_hw)
        ? globalThis.Boolean(object.corrected_hw)
        : false,
      sessionName: isSet(object.sessionName)
        ? globalThis.String(object.sessionName)
        : isSet(object.session_name)
        ? globalThis.String(object.session_name)
        : "",
      cropId: isSet(object.cropId)
        ? globalThis.String(object.cropId)
        : isSet(object.crop_id)
        ? globalThis.String(object.crop_id)
        : "",
      focusMetric: isSet(object.focusMetric)
        ? globalThis.Number(object.focusMetric)
        : isSet(object.focus_metric)
        ? globalThis.Number(object.focus_metric)
        : 0,
      geohash: isSet(object.geohash) ? globalThis.String(object.geohash) : "",
      quarantineReason: isSet(object.quarantineReason)
        ? globalThis.String(object.quarantineReason)
        : isSet(object.quarantine_reason)
        ? globalThis.String(object.quarantine_reason)
        : "",
    };
  },

  toJSON(message: Image): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.robotId !== "") {
      obj.robotId = message.robotId;
    }
    if (message.useCase !== "") {
      obj.useCase = message.useCase;
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    if (message.ppi !== 0) {
      obj.ppi = Math.round(message.ppi);
    }
    if (message.valid !== 0) {
      obj.valid = Math.round(message.valid);
    }
    if (message.capturedAt !== 0) {
      obj.capturedAt = Math.round(message.capturedAt);
    }
    if (message.detectionJson !== "") {
      obj.detectionJson = message.detectionJson;
    }
    if (message.reasonJson !== "") {
      obj.reasonJson = message.reasonJson;
    }
    if (message.priority !== "") {
      obj.priority = message.priority;
    }
    if (message.camId !== "") {
      obj.camId = message.camId;
    }
    if (message.rowId !== "") {
      obj.rowId = message.rowId;
    }
    if (message.geoJson !== "") {
      obj.geoJson = message.geoJson;
    }
    if (message.crop !== "") {
      obj.crop = message.crop;
    }
    if (message.imageType !== "") {
      obj.imageType = message.imageType;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.correctedHw !== false) {
      obj.correctedHw = message.correctedHw;
    }
    if (message.sessionName !== "") {
      obj.sessionName = message.sessionName;
    }
    if (message.cropId !== "") {
      obj.cropId = message.cropId;
    }
    if (message.focusMetric !== 0) {
      obj.focusMetric = Math.round(message.focusMetric);
    }
    if (message.geohash !== "") {
      obj.geohash = message.geohash;
    }
    if (message.quarantineReason !== "") {
      obj.quarantineReason = message.quarantineReason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Image>, I>>(base?: I): Image {
    return Image.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Image>, I>>(object: I): Image {
    const message = createBaseImage();
    message.id = object.id ?? "";
    message.location = object.location ?? "";
    message.robotId = object.robotId ?? "";
    message.useCase = object.useCase ?? "";
    message.role = object.role ?? "";
    message.created = object.created ?? 0;
    message.url = object.url ?? "";
    message.height = object.height ?? 0;
    message.width = object.width ?? 0;
    message.ppi = object.ppi ?? 0;
    message.valid = object.valid ?? 0;
    message.capturedAt = object.capturedAt ?? 0;
    message.detectionJson = object.detectionJson ?? "";
    message.reasonJson = object.reasonJson ?? "";
    message.priority = object.priority ?? "";
    message.camId = object.camId ?? "";
    message.rowId = object.rowId ?? "";
    message.geoJson = object.geoJson ?? "";
    message.crop = object.crop ?? "";
    message.imageType = object.imageType ?? "";
    message.city = object.city ?? "";
    message.correctedHw = object.correctedHw ?? false;
    message.sessionName = object.sessionName ?? "";
    message.cropId = object.cropId ?? "";
    message.focusMetric = object.focusMetric ?? 0;
    message.geohash = object.geohash ?? "";
    message.quarantineReason = object.quarantineReason ?? "";
    return message;
  },
};

function createBaseCropConfidence(): CropConfidence {
  return {
    db: undefined,
    robotId: 0,
    cropId: "",
    latitude: 0,
    longitude: 0,
    precision: 0,
    numTotalImages: 0,
    numRegionalImages: 0,
    confidence: "",
  };
}

export const CropConfidence: MessageFns<CropConfidence> = {
  encode(message: CropConfidence, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.db !== undefined) {
      DB.encode(message.db, writer.uint32(10).fork()).join();
    }
    if (message.robotId !== 0) {
      writer.uint32(16).int64(message.robotId);
    }
    if (message.cropId !== "") {
      writer.uint32(26).string(message.cropId);
    }
    if (message.latitude !== 0) {
      writer.uint32(37).float(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(45).float(message.longitude);
    }
    if (message.precision !== 0) {
      writer.uint32(48).int64(message.precision);
    }
    if (message.numTotalImages !== 0) {
      writer.uint32(56).int64(message.numTotalImages);
    }
    if (message.numRegionalImages !== 0) {
      writer.uint32(64).int64(message.numRegionalImages);
    }
    if (message.confidence !== "") {
      writer.uint32(74).string(message.confidence);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CropConfidence {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCropConfidence();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.db = DB.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.robotId = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cropId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.latitude = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.longitude = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.precision = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.numTotalImages = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.numRegionalImages = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.confidence = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CropConfidence {
    return {
      db: isSet(object.db) ? DB.fromJSON(object.db) : undefined,
      robotId: isSet(object.robotId)
        ? globalThis.Number(object.robotId)
        : isSet(object.robot_id)
        ? globalThis.Number(object.robot_id)
        : 0,
      cropId: isSet(object.cropId)
        ? globalThis.String(object.cropId)
        : isSet(object.crop_id)
        ? globalThis.String(object.crop_id)
        : "",
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      precision: isSet(object.precision) ? globalThis.Number(object.precision) : 0,
      numTotalImages: isSet(object.numTotalImages)
        ? globalThis.Number(object.numTotalImages)
        : isSet(object.num_total_images)
        ? globalThis.Number(object.num_total_images)
        : 0,
      numRegionalImages: isSet(object.numRegionalImages)
        ? globalThis.Number(object.numRegionalImages)
        : isSet(object.num_regional_images)
        ? globalThis.Number(object.num_regional_images)
        : 0,
      confidence: isSet(object.confidence) ? globalThis.String(object.confidence) : "",
    };
  },

  toJSON(message: CropConfidence): unknown {
    const obj: any = {};
    if (message.db !== undefined) {
      obj.db = DB.toJSON(message.db);
    }
    if (message.robotId !== 0) {
      obj.robotId = Math.round(message.robotId);
    }
    if (message.cropId !== "") {
      obj.cropId = message.cropId;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.precision !== 0) {
      obj.precision = Math.round(message.precision);
    }
    if (message.numTotalImages !== 0) {
      obj.numTotalImages = Math.round(message.numTotalImages);
    }
    if (message.numRegionalImages !== 0) {
      obj.numRegionalImages = Math.round(message.numRegionalImages);
    }
    if (message.confidence !== "") {
      obj.confidence = message.confidence;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CropConfidence>, I>>(base?: I): CropConfidence {
    return CropConfidence.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CropConfidence>, I>>(object: I): CropConfidence {
    const message = createBaseCropConfidence();
    message.db = (object.db !== undefined && object.db !== null) ? DB.fromPartial(object.db) : undefined;
    message.robotId = object.robotId ?? 0;
    message.cropId = object.cropId ?? "";
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.precision = object.precision ?? 0;
    message.numTotalImages = object.numTotalImages ?? 0;
    message.numRegionalImages = object.numRegionalImages ?? 0;
    message.confidence = object.confidence ?? "";
    return message;
  },
};

function createBaseCrop(): Crop {
  return {
    archived: false,
    carbonName: "",
    commonName: "",
    created: 0,
    description: "",
    id: "",
    legacyCropName: "",
    notes: "",
    updated: 0,
    captureOnly: false,
    translations: [],
  };
}

export const Crop: MessageFns<Crop> = {
  encode(message: Crop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.archived !== false) {
      writer.uint32(8).bool(message.archived);
    }
    if (message.carbonName !== "") {
      writer.uint32(18).string(message.carbonName);
    }
    if (message.commonName !== "") {
      writer.uint32(26).string(message.commonName);
    }
    if (message.created !== 0) {
      writer.uint32(32).int64(message.created);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    if (message.id !== "") {
      writer.uint32(50).string(message.id);
    }
    if (message.legacyCropName !== "") {
      writer.uint32(58).string(message.legacyCropName);
    }
    if (message.notes !== "") {
      writer.uint32(66).string(message.notes);
    }
    if (message.updated !== 0) {
      writer.uint32(72).int64(message.updated);
    }
    if (message.captureOnly !== false) {
      writer.uint32(80).bool(message.captureOnly);
    }
    for (const v of message.translations) {
      CropTranslation.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Crop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.carbonName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commonName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.created = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.legacyCropName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.updated = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.captureOnly = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.translations.push(CropTranslation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Crop {
    return {
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      carbonName: isSet(object.carbonName)
        ? globalThis.String(object.carbonName)
        : isSet(object.carbon_name)
        ? globalThis.String(object.carbon_name)
        : "",
      commonName: isSet(object.commonName)
        ? globalThis.String(object.commonName)
        : isSet(object.common_name)
        ? globalThis.String(object.common_name)
        : "",
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      legacyCropName: isSet(object.legacyCropName)
        ? globalThis.String(object.legacyCropName)
        : isSet(object.legacy_crop_name)
        ? globalThis.String(object.legacy_crop_name)
        : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      updated: isSet(object.updated) ? globalThis.Number(object.updated) : 0,
      captureOnly: isSet(object.captureOnly)
        ? globalThis.Boolean(object.captureOnly)
        : isSet(object.capture_only)
        ? globalThis.Boolean(object.capture_only)
        : false,
      translations: globalThis.Array.isArray(object?.translations)
        ? object.translations.map((e: any) => CropTranslation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Crop): unknown {
    const obj: any = {};
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.carbonName !== "") {
      obj.carbonName = message.carbonName;
    }
    if (message.commonName !== "") {
      obj.commonName = message.commonName;
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.legacyCropName !== "") {
      obj.legacyCropName = message.legacyCropName;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.updated !== 0) {
      obj.updated = Math.round(message.updated);
    }
    if (message.captureOnly !== false) {
      obj.captureOnly = message.captureOnly;
    }
    if (message.translations?.length) {
      obj.translations = message.translations.map((e) => CropTranslation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Crop>, I>>(base?: I): Crop {
    return Crop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Crop>, I>>(object: I): Crop {
    const message = createBaseCrop();
    message.archived = object.archived ?? false;
    message.carbonName = object.carbonName ?? "";
    message.commonName = object.commonName ?? "";
    message.created = object.created ?? 0;
    message.description = object.description ?? "";
    message.id = object.id ?? "";
    message.legacyCropName = object.legacyCropName ?? "";
    message.notes = object.notes ?? "";
    message.updated = object.updated ?? 0;
    message.captureOnly = object.captureOnly ?? false;
    message.translations = object.translations?.map((e) => CropTranslation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCropTranslation(): CropTranslation {
  return { language: "", name: "", version: 0 };
}

export const CropTranslation: MessageFns<CropTranslation> = {
  encode(message: CropTranslation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.language !== "") {
      writer.uint32(10).string(message.language);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.version !== 0) {
      writer.uint32(24).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CropTranslation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCropTranslation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.language = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CropTranslation {
    return {
      language: isSet(object.language) ? globalThis.String(object.language) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: CropTranslation): unknown {
    const obj: any = {};
    if (message.language !== "") {
      obj.language = message.language;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CropTranslation>, I>>(base?: I): CropTranslation {
    return CropTranslation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CropTranslation>, I>>(object: I): CropTranslation {
    const message = createBaseCropTranslation();
    message.language = object.language ?? "";
    message.name = object.name ?? "";
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseRobotCrop(): RobotCrop {
  return { crop: undefined, confidence: undefined };
}

export const RobotCrop: MessageFns<RobotCrop> = {
  encode(message: RobotCrop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.crop !== undefined) {
      Crop.encode(message.crop, writer.uint32(10).fork()).join();
    }
    if (message.confidence !== undefined) {
      CropConfidence.encode(message.confidence, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotCrop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotCrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crop = Crop.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.confidence = CropConfidence.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotCrop {
    return {
      crop: isSet(object.crop) ? Crop.fromJSON(object.crop) : undefined,
      confidence: isSet(object.confidence) ? CropConfidence.fromJSON(object.confidence) : undefined,
    };
  },

  toJSON(message: RobotCrop): unknown {
    const obj: any = {};
    if (message.crop !== undefined) {
      obj.crop = Crop.toJSON(message.crop);
    }
    if (message.confidence !== undefined) {
      obj.confidence = CropConfidence.toJSON(message.confidence);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotCrop>, I>>(base?: I): RobotCrop {
    return RobotCrop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotCrop>, I>>(object: I): RobotCrop {
    const message = createBaseRobotCrop();
    message.crop = (object.crop !== undefined && object.crop !== null) ? Crop.fromPartial(object.crop) : undefined;
    message.confidence = (object.confidence !== undefined && object.confidence !== null)
      ? CropConfidence.fromPartial(object.confidence)
      : undefined;
    return message;
  },
};

function createBaseModel(): Model {
  return {
    id: "",
    created: 0,
    updated: 0,
    url: "",
    customer: "",
    crop: "",
    version: 0,
    trainingDockerTag: "",
    gitSha: "",
    checksum: "",
    location: "",
    trainedAt: 0,
    type: "",
    description: "",
    metadataJson: "",
    productionContainerVersion: "",
    testResultsJson: "",
    wandbJson: "",
    snapshotJson: "",
    isStub: false,
    isGoodToDeploy: false,
    robotName: "",
    environment: "",
    deploy: false,
    isPretraining: false,
    subType: "",
    datasetId: "",
    containerVersion: "",
    containerId: "",
    pipelineId: "",
    parentModelId: "",
    viableCropIds: [],
  };
}

export const Model: MessageFns<Model> = {
  encode(message: Model, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.created !== 0) {
      writer.uint32(16).int64(message.created);
    }
    if (message.updated !== 0) {
      writer.uint32(24).int64(message.updated);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    if (message.customer !== "") {
      writer.uint32(42).string(message.customer);
    }
    if (message.crop !== "") {
      writer.uint32(50).string(message.crop);
    }
    if (message.version !== 0) {
      writer.uint32(56).int64(message.version);
    }
    if (message.trainingDockerTag !== "") {
      writer.uint32(66).string(message.trainingDockerTag);
    }
    if (message.gitSha !== "") {
      writer.uint32(74).string(message.gitSha);
    }
    if (message.checksum !== "") {
      writer.uint32(82).string(message.checksum);
    }
    if (message.location !== "") {
      writer.uint32(90).string(message.location);
    }
    if (message.trainedAt !== 0) {
      writer.uint32(96).int64(message.trainedAt);
    }
    if (message.type !== "") {
      writer.uint32(106).string(message.type);
    }
    if (message.description !== "") {
      writer.uint32(114).string(message.description);
    }
    if (message.metadataJson !== "") {
      writer.uint32(122).string(message.metadataJson);
    }
    if (message.productionContainerVersion !== "") {
      writer.uint32(130).string(message.productionContainerVersion);
    }
    if (message.testResultsJson !== "") {
      writer.uint32(138).string(message.testResultsJson);
    }
    if (message.wandbJson !== "") {
      writer.uint32(146).string(message.wandbJson);
    }
    if (message.snapshotJson !== "") {
      writer.uint32(154).string(message.snapshotJson);
    }
    if (message.isStub !== false) {
      writer.uint32(160).bool(message.isStub);
    }
    if (message.isGoodToDeploy !== false) {
      writer.uint32(168).bool(message.isGoodToDeploy);
    }
    if (message.robotName !== "") {
      writer.uint32(178).string(message.robotName);
    }
    if (message.environment !== "") {
      writer.uint32(186).string(message.environment);
    }
    if (message.deploy !== false) {
      writer.uint32(192).bool(message.deploy);
    }
    if (message.isPretraining !== false) {
      writer.uint32(200).bool(message.isPretraining);
    }
    if (message.subType !== "") {
      writer.uint32(210).string(message.subType);
    }
    if (message.datasetId !== "") {
      writer.uint32(218).string(message.datasetId);
    }
    if (message.containerVersion !== "") {
      writer.uint32(226).string(message.containerVersion);
    }
    if (message.containerId !== "") {
      writer.uint32(234).string(message.containerId);
    }
    if (message.pipelineId !== "") {
      writer.uint32(242).string(message.pipelineId);
    }
    if (message.parentModelId !== "") {
      writer.uint32(250).string(message.parentModelId);
    }
    for (const v of message.viableCropIds) {
      writer.uint32(258).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Model {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.created = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.updated = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.customer = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.crop = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.trainingDockerTag = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.gitSha = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.checksum = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.trainedAt = longToNumber(reader.int64());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.metadataJson = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.productionContainerVersion = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.testResultsJson = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.wandbJson = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.snapshotJson = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.isStub = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.isGoodToDeploy = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.robotName = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.environment = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.deploy = reader.bool();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.isPretraining = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.subType = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.datasetId = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.containerVersion = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.containerId = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.pipelineId = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.parentModelId = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.viableCropIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Model {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      updated: isSet(object.updated) ? globalThis.Number(object.updated) : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      customer: isSet(object.customer) ? globalThis.String(object.customer) : "",
      crop: isSet(object.crop) ? globalThis.String(object.crop) : "",
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
      trainingDockerTag: isSet(object.trainingDockerTag)
        ? globalThis.String(object.trainingDockerTag)
        : isSet(object.training_docker_tag)
        ? globalThis.String(object.training_docker_tag)
        : "",
      gitSha: isSet(object.gitSha) ? globalThis.String(object.gitSha) : "",
      checksum: isSet(object.checksum) ? globalThis.String(object.checksum) : "",
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      trainedAt: isSet(object.trainedAt)
        ? globalThis.Number(object.trainedAt)
        : isSet(object.trained_at)
        ? globalThis.Number(object.trained_at)
        : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      metadataJson: isSet(object.metadataJson)
        ? globalThis.String(object.metadataJson)
        : isSet(object.metadata_json)
        ? globalThis.String(object.metadata_json)
        : "",
      productionContainerVersion: isSet(object.productionContainerVersion)
        ? globalThis.String(object.productionContainerVersion)
        : isSet(object.production_container_version)
        ? globalThis.String(object.production_container_version)
        : "",
      testResultsJson: isSet(object.testResultsJson)
        ? globalThis.String(object.testResultsJson)
        : isSet(object.test_results_json)
        ? globalThis.String(object.test_results_json)
        : "",
      wandbJson: isSet(object.wandbJson)
        ? globalThis.String(object.wandbJson)
        : isSet(object.wandb_json)
        ? globalThis.String(object.wandb_json)
        : "",
      snapshotJson: isSet(object.snapshotJson)
        ? globalThis.String(object.snapshotJson)
        : isSet(object.snapshot_json)
        ? globalThis.String(object.snapshot_json)
        : "",
      isStub: isSet(object.isStub)
        ? globalThis.Boolean(object.isStub)
        : isSet(object.is_stub)
        ? globalThis.Boolean(object.is_stub)
        : false,
      isGoodToDeploy: isSet(object.isGoodToDeploy)
        ? globalThis.Boolean(object.isGoodToDeploy)
        : isSet(object.is_good_to_deploy)
        ? globalThis.Boolean(object.is_good_to_deploy)
        : false,
      robotName: isSet(object.robotName)
        ? globalThis.String(object.robotName)
        : isSet(object.robot_name)
        ? globalThis.String(object.robot_name)
        : "",
      environment: isSet(object.environment) ? globalThis.String(object.environment) : "",
      deploy: isSet(object.deploy) ? globalThis.Boolean(object.deploy) : false,
      isPretraining: isSet(object.isPretraining)
        ? globalThis.Boolean(object.isPretraining)
        : isSet(object.is_pretraining)
        ? globalThis.Boolean(object.is_pretraining)
        : false,
      subType: isSet(object.subType)
        ? globalThis.String(object.subType)
        : isSet(object.sub_type)
        ? globalThis.String(object.sub_type)
        : "",
      datasetId: isSet(object.datasetId)
        ? globalThis.String(object.datasetId)
        : isSet(object.dataset_id)
        ? globalThis.String(object.dataset_id)
        : "",
      containerVersion: isSet(object.containerVersion)
        ? globalThis.String(object.containerVersion)
        : isSet(object.container_version)
        ? globalThis.String(object.container_version)
        : "",
      containerId: isSet(object.containerId)
        ? globalThis.String(object.containerId)
        : isSet(object.container_id)
        ? globalThis.String(object.container_id)
        : "",
      pipelineId: isSet(object.pipelineId)
        ? globalThis.String(object.pipelineId)
        : isSet(object.pipeline_id)
        ? globalThis.String(object.pipeline_id)
        : "",
      parentModelId: isSet(object.parentModelId)
        ? globalThis.String(object.parentModelId)
        : isSet(object.parent_model_id)
        ? globalThis.String(object.parent_model_id)
        : "",
      viableCropIds: globalThis.Array.isArray(object?.viableCropIds)
        ? object.viableCropIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.viable_crop_ids)
        ? object.viable_crop_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Model): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.updated !== 0) {
      obj.updated = Math.round(message.updated);
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.customer !== "") {
      obj.customer = message.customer;
    }
    if (message.crop !== "") {
      obj.crop = message.crop;
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    if (message.trainingDockerTag !== "") {
      obj.trainingDockerTag = message.trainingDockerTag;
    }
    if (message.gitSha !== "") {
      obj.gitSha = message.gitSha;
    }
    if (message.checksum !== "") {
      obj.checksum = message.checksum;
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.trainedAt !== 0) {
      obj.trainedAt = Math.round(message.trainedAt);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.metadataJson !== "") {
      obj.metadataJson = message.metadataJson;
    }
    if (message.productionContainerVersion !== "") {
      obj.productionContainerVersion = message.productionContainerVersion;
    }
    if (message.testResultsJson !== "") {
      obj.testResultsJson = message.testResultsJson;
    }
    if (message.wandbJson !== "") {
      obj.wandbJson = message.wandbJson;
    }
    if (message.snapshotJson !== "") {
      obj.snapshotJson = message.snapshotJson;
    }
    if (message.isStub !== false) {
      obj.isStub = message.isStub;
    }
    if (message.isGoodToDeploy !== false) {
      obj.isGoodToDeploy = message.isGoodToDeploy;
    }
    if (message.robotName !== "") {
      obj.robotName = message.robotName;
    }
    if (message.environment !== "") {
      obj.environment = message.environment;
    }
    if (message.deploy !== false) {
      obj.deploy = message.deploy;
    }
    if (message.isPretraining !== false) {
      obj.isPretraining = message.isPretraining;
    }
    if (message.subType !== "") {
      obj.subType = message.subType;
    }
    if (message.datasetId !== "") {
      obj.datasetId = message.datasetId;
    }
    if (message.containerVersion !== "") {
      obj.containerVersion = message.containerVersion;
    }
    if (message.containerId !== "") {
      obj.containerId = message.containerId;
    }
    if (message.pipelineId !== "") {
      obj.pipelineId = message.pipelineId;
    }
    if (message.parentModelId !== "") {
      obj.parentModelId = message.parentModelId;
    }
    if (message.viableCropIds?.length) {
      obj.viableCropIds = message.viableCropIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Model>, I>>(base?: I): Model {
    return Model.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Model>, I>>(object: I): Model {
    const message = createBaseModel();
    message.id = object.id ?? "";
    message.created = object.created ?? 0;
    message.updated = object.updated ?? 0;
    message.url = object.url ?? "";
    message.customer = object.customer ?? "";
    message.crop = object.crop ?? "";
    message.version = object.version ?? 0;
    message.trainingDockerTag = object.trainingDockerTag ?? "";
    message.gitSha = object.gitSha ?? "";
    message.checksum = object.checksum ?? "";
    message.location = object.location ?? "";
    message.trainedAt = object.trainedAt ?? 0;
    message.type = object.type ?? "";
    message.description = object.description ?? "";
    message.metadataJson = object.metadataJson ?? "";
    message.productionContainerVersion = object.productionContainerVersion ?? "";
    message.testResultsJson = object.testResultsJson ?? "";
    message.wandbJson = object.wandbJson ?? "";
    message.snapshotJson = object.snapshotJson ?? "";
    message.isStub = object.isStub ?? false;
    message.isGoodToDeploy = object.isGoodToDeploy ?? false;
    message.robotName = object.robotName ?? "";
    message.environment = object.environment ?? "";
    message.deploy = object.deploy ?? false;
    message.isPretraining = object.isPretraining ?? false;
    message.subType = object.subType ?? "";
    message.datasetId = object.datasetId ?? "";
    message.containerVersion = object.containerVersion ?? "";
    message.containerId = object.containerId ?? "";
    message.pipelineId = object.pipelineId ?? "";
    message.parentModelId = object.parentModelId ?? "";
    message.viableCropIds = object.viableCropIds?.map((e) => e) || [];
    return message;
  },
};

function createBasePageSortParams(): PageSortParams {
  return { page: 0, pageSize: 0, sortBy: undefined, sortDirection: undefined };
}

export const PageSortParams: MessageFns<PageSortParams> = {
  encode(message: PageSortParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.page !== 0) {
      writer.uint32(8).int64(message.page);
    }
    if (message.pageSize !== 0) {
      writer.uint32(16).int64(message.pageSize);
    }
    if (message.sortBy !== undefined) {
      writer.uint32(26).string(message.sortBy);
    }
    if (message.sortDirection !== undefined) {
      writer.uint32(34).string(message.sortDirection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PageSortParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePageSortParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.page = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pageSize = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sortBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sortDirection = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PageSortParams {
    return {
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      sortBy: isSet(object.sortBy)
        ? globalThis.String(object.sortBy)
        : isSet(object.sort_by)
        ? globalThis.String(object.sort_by)
        : undefined,
      sortDirection: isSet(object.sortDirection)
        ? globalThis.String(object.sortDirection)
        : isSet(object.sort_direction)
        ? globalThis.String(object.sort_direction)
        : undefined,
    };
  },

  toJSON(message: PageSortParams): unknown {
    const obj: any = {};
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.sortBy !== undefined) {
      obj.sortBy = message.sortBy;
    }
    if (message.sortDirection !== undefined) {
      obj.sortDirection = message.sortDirection;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PageSortParams>, I>>(base?: I): PageSortParams {
    return PageSortParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PageSortParams>, I>>(object: I): PageSortParams {
    const message = createBasePageSortParams();
    message.page = object.page ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.sortBy = object.sortBy ?? undefined;
    message.sortDirection = object.sortDirection ?? undefined;
    return message;
  },
};

function createBasePredictionPointSessionFilters(): PredictionPointSessionFilters {
  return { sessionId: undefined, categoryIds: [] };
}

export const PredictionPointSessionFilters: MessageFns<PredictionPointSessionFilters> = {
  encode(message: PredictionPointSessionFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== undefined) {
      writer.uint32(10).string(message.sessionId);
    }
    for (const v of message.categoryIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PredictionPointSessionFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePredictionPointSessionFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.categoryIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PredictionPointSessionFilters {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
        ? globalThis.String(object.session_id)
        : undefined,
      categoryIds: globalThis.Array.isArray(object?.categoryIds)
        ? object.categoryIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.category_ids)
        ? object.category_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: PredictionPointSessionFilters): unknown {
    const obj: any = {};
    if (message.sessionId !== undefined) {
      obj.sessionId = message.sessionId;
    }
    if (message.categoryIds?.length) {
      obj.categoryIds = message.categoryIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PredictionPointSessionFilters>, I>>(base?: I): PredictionPointSessionFilters {
    return PredictionPointSessionFilters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PredictionPointSessionFilters>, I>>(
    object: I,
  ): PredictionPointSessionFilters {
    const message = createBasePredictionPointSessionFilters();
    message.sessionId = object.sessionId ?? undefined;
    message.categoryIds = object.categoryIds?.map((e) => e) || [];
    return message;
  },
};

function createBasePredictionPointBaseFilters(): PredictionPointBaseFilters {
  return {
    ids: [],
    capturedAtStart: undefined,
    capturedAtEnd: undefined,
    radiusMin: undefined,
    radiusMax: undefined,
    cropIds: [],
    robotSerials: [],
    uploadedByOperator: undefined,
    customerIds: [],
    ppCategoryId: undefined,
    carbonCropIds: [],
  };
}

export const PredictionPointBaseFilters: MessageFns<PredictionPointBaseFilters> = {
  encode(message: PredictionPointBaseFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ids) {
      writer.uint32(10).string(v!);
    }
    if (message.capturedAtStart !== undefined) {
      writer.uint32(18).string(message.capturedAtStart);
    }
    if (message.capturedAtEnd !== undefined) {
      writer.uint32(26).string(message.capturedAtEnd);
    }
    if (message.radiusMin !== undefined) {
      writer.uint32(37).float(message.radiusMin);
    }
    if (message.radiusMax !== undefined) {
      writer.uint32(45).float(message.radiusMax);
    }
    for (const v of message.cropIds) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.robotSerials) {
      writer.uint32(58).string(v!);
    }
    if (message.uploadedByOperator !== undefined) {
      writer.uint32(64).bool(message.uploadedByOperator);
    }
    for (const v of message.customerIds) {
      writer.uint32(74).string(v!);
    }
    if (message.ppCategoryId !== undefined) {
      writer.uint32(82).string(message.ppCategoryId);
    }
    for (const v of message.carbonCropIds) {
      writer.uint32(90).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PredictionPointBaseFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePredictionPointBaseFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.capturedAtStart = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.capturedAtEnd = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.radiusMin = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.radiusMax = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cropIds.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.robotSerials.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.uploadedByOperator = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.customerIds.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ppCategoryId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.carbonCropIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PredictionPointBaseFilters {
    return {
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      capturedAtStart: isSet(object.capturedAtStart)
        ? globalThis.String(object.capturedAtStart)
        : isSet(object.captured_at_start)
        ? globalThis.String(object.captured_at_start)
        : undefined,
      capturedAtEnd: isSet(object.capturedAtEnd)
        ? globalThis.String(object.capturedAtEnd)
        : isSet(object.captured_at_end)
        ? globalThis.String(object.captured_at_end)
        : undefined,
      radiusMin: isSet(object.radiusMin)
        ? globalThis.Number(object.radiusMin)
        : isSet(object.radius_min)
        ? globalThis.Number(object.radius_min)
        : undefined,
      radiusMax: isSet(object.radiusMax)
        ? globalThis.Number(object.radiusMax)
        : isSet(object.radius_max)
        ? globalThis.Number(object.radius_max)
        : undefined,
      cropIds: globalThis.Array.isArray(object?.cropIds)
        ? object.cropIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.crop_ids)
        ? object.crop_ids.map((e: any) => globalThis.String(e))
        : [],
      robotSerials: globalThis.Array.isArray(object?.robotSerials)
        ? object.robotSerials.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.robot_serials)
        ? object.robot_serials.map((e: any) => globalThis.String(e))
        : [],
      uploadedByOperator: isSet(object.uploadedByOperator)
        ? globalThis.Boolean(object.uploadedByOperator)
        : isSet(object.uploaded_by_operator)
        ? globalThis.Boolean(object.uploaded_by_operator)
        : undefined,
      customerIds: globalThis.Array.isArray(object?.customerIds)
        ? object.customerIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.customer_ids)
        ? object.customer_ids.map((e: any) => globalThis.String(e))
        : [],
      ppCategoryId: isSet(object.ppCategoryId)
        ? globalThis.String(object.ppCategoryId)
        : isSet(object.pp_category_id)
        ? globalThis.String(object.pp_category_id)
        : undefined,
      carbonCropIds: globalThis.Array.isArray(object?.carbonCropIds)
        ? object.carbonCropIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.carbon_crop_ids)
        ? object.carbon_crop_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: PredictionPointBaseFilters): unknown {
    const obj: any = {};
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.capturedAtStart !== undefined) {
      obj.capturedAtStart = message.capturedAtStart;
    }
    if (message.capturedAtEnd !== undefined) {
      obj.capturedAtEnd = message.capturedAtEnd;
    }
    if (message.radiusMin !== undefined) {
      obj.radiusMin = message.radiusMin;
    }
    if (message.radiusMax !== undefined) {
      obj.radiusMax = message.radiusMax;
    }
    if (message.cropIds?.length) {
      obj.cropIds = message.cropIds;
    }
    if (message.robotSerials?.length) {
      obj.robotSerials = message.robotSerials;
    }
    if (message.uploadedByOperator !== undefined) {
      obj.uploadedByOperator = message.uploadedByOperator;
    }
    if (message.customerIds?.length) {
      obj.customerIds = message.customerIds;
    }
    if (message.ppCategoryId !== undefined) {
      obj.ppCategoryId = message.ppCategoryId;
    }
    if (message.carbonCropIds?.length) {
      obj.carbonCropIds = message.carbonCropIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PredictionPointBaseFilters>, I>>(base?: I): PredictionPointBaseFilters {
    return PredictionPointBaseFilters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PredictionPointBaseFilters>, I>>(object: I): PredictionPointBaseFilters {
    const message = createBasePredictionPointBaseFilters();
    message.ids = object.ids?.map((e) => e) || [];
    message.capturedAtStart = object.capturedAtStart ?? undefined;
    message.capturedAtEnd = object.capturedAtEnd ?? undefined;
    message.radiusMin = object.radiusMin ?? undefined;
    message.radiusMax = object.radiusMax ?? undefined;
    message.cropIds = object.cropIds?.map((e) => e) || [];
    message.robotSerials = object.robotSerials?.map((e) => e) || [];
    message.uploadedByOperator = object.uploadedByOperator ?? undefined;
    message.customerIds = object.customerIds?.map((e) => e) || [];
    message.ppCategoryId = object.ppCategoryId ?? undefined;
    message.carbonCropIds = object.carbonCropIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateCategoryCollectionSessionRequest(): CreateCategoryCollectionSessionRequest {
  return { modelId: "", customerId: undefined, customerUuid: undefined, plantProfile: undefined, filters: undefined };
}

export const CreateCategoryCollectionSessionRequest: MessageFns<CreateCategoryCollectionSessionRequest> = {
  encode(message: CreateCategoryCollectionSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.customerId !== undefined) {
      writer.uint32(16).uint64(message.customerId);
    }
    if (message.customerUuid !== undefined) {
      writer.uint32(42).string(message.customerUuid);
    }
    if (message.plantProfile !== undefined) {
      CategoryCollectionProfile.encode(message.plantProfile, writer.uint32(26).fork()).join();
    }
    if (message.filters !== undefined) {
      PredictionPointBaseFilters.encode(message.filters, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCategoryCollectionSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCategoryCollectionSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.customerId = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.customerUuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.plantProfile = CategoryCollectionProfile.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.filters = PredictionPointBaseFilters.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCategoryCollectionSessionRequest {
    return {
      modelId: isSet(object.modelId)
        ? globalThis.String(object.modelId)
        : isSet(object.model_id)
        ? globalThis.String(object.model_id)
        : "",
      customerId: isSet(object.customerId)
        ? globalThis.Number(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.Number(object.customer_id)
        : undefined,
      customerUuid: isSet(object.customerUuid)
        ? globalThis.String(object.customerUuid)
        : isSet(object.customer_uuid)
        ? globalThis.String(object.customer_uuid)
        : undefined,
      plantProfile: isSet(object.plantProfile)
        ? CategoryCollectionProfile.fromJSON(object.plantProfile)
        : isSet(object.plant_profile)
        ? CategoryCollectionProfile.fromJSON(object.plant_profile)
        : undefined,
      filters: isSet(object.filters) ? PredictionPointBaseFilters.fromJSON(object.filters) : undefined,
    };
  },

  toJSON(message: CreateCategoryCollectionSessionRequest): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.customerId !== undefined) {
      obj.customerId = Math.round(message.customerId);
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.plantProfile !== undefined) {
      obj.plantProfile = CategoryCollectionProfile.toJSON(message.plantProfile);
    }
    if (message.filters !== undefined) {
      obj.filters = PredictionPointBaseFilters.toJSON(message.filters);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCategoryCollectionSessionRequest>, I>>(
    base?: I,
  ): CreateCategoryCollectionSessionRequest {
    return CreateCategoryCollectionSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCategoryCollectionSessionRequest>, I>>(
    object: I,
  ): CreateCategoryCollectionSessionRequest {
    const message = createBaseCreateCategoryCollectionSessionRequest();
    message.modelId = object.modelId ?? "";
    message.customerId = object.customerId ?? undefined;
    message.customerUuid = object.customerUuid ?? undefined;
    message.plantProfile = (object.plantProfile !== undefined && object.plantProfile !== null)
      ? CategoryCollectionProfile.fromPartial(object.plantProfile)
      : undefined;
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? PredictionPointBaseFilters.fromPartial(object.filters)
      : undefined;
    return message;
  },
};

function createBaseCreateCategoryCollectionSessionResponse(): CreateCategoryCollectionSessionResponse {
  return { sessionId: "", status: 0, cropIds: [] };
}

export const CreateCategoryCollectionSessionResponse: MessageFns<CreateCategoryCollectionSessionResponse> = {
  encode(message: CreateCategoryCollectionSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== "") {
      writer.uint32(10).string(message.sessionId);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    for (const v of message.cropIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCategoryCollectionSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCategoryCollectionSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cropIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCategoryCollectionSessionResponse {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
        ? globalThis.String(object.session_id)
        : "",
      status: isSet(object.status) ? sessionActivityStateFromJSON(object.status) : 0,
      cropIds: globalThis.Array.isArray(object?.cropIds)
        ? object.cropIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.crop_ids)
        ? object.crop_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: CreateCategoryCollectionSessionResponse): unknown {
    const obj: any = {};
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.status !== 0) {
      obj.status = sessionActivityStateToJSON(message.status);
    }
    if (message.cropIds?.length) {
      obj.cropIds = message.cropIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCategoryCollectionSessionResponse>, I>>(
    base?: I,
  ): CreateCategoryCollectionSessionResponse {
    return CreateCategoryCollectionSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCategoryCollectionSessionResponse>, I>>(
    object: I,
  ): CreateCategoryCollectionSessionResponse {
    const message = createBaseCreateCategoryCollectionSessionResponse();
    message.sessionId = object.sessionId ?? "";
    message.status = object.status ?? 0;
    message.cropIds = object.cropIds?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
